export const payoutMethodStatusColorMap = {
  CREATED: 'warning',
  PENDING_SUBMISSION: 'info',
  SUBMITTED: 'info',
  CHANGE_REQUESTED: 'alert',
  REJECTED: 'alert',
  NEED_MORE_INFORMATION: 'alert',
  ENABLED: 'success',
}
